// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "common" + "." + "2975d05a2ed5c15060b9" + ".js";
};